import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";

export default function SpanningTable({
  invoiceArenda,
  invoiceNalog,
  paymentArenda,
  paymentNalog,
}) {
  const totalInvoiceArenda = invoiceArenda
    .reduce((sum, current) => sum + Number(current), 0)
    .toFixed(3);

  const totalInvoiceNalog = invoiceNalog
    .reduce((sum, current) => sum + Number(current), 0)
    .toFixed(3);

  const summaryInvoice = (
    Number(totalInvoiceArenda) + Number(totalInvoiceNalog)
  ).toFixed(3);

  const totalPaymentArenda = paymentArenda
    .reduce((sum, current) => sum + Number(current), 0)
    .toFixed(3);

  const totalPaymentNalog = paymentNalog
    .reduce((sum, current) => sum + Number(current), 0)
    .toFixed(3);

  const summaryPayment = (
    Number(totalPaymentArenda) + Number(totalPaymentNalog)
  ).toFixed(3);

  const differenceArenda = (totalInvoiceArenda - totalPaymentArenda).toFixed(3);
  const differenceNalog = (totalInvoiceNalog - totalPaymentNalog).toFixed(3);

  const summuryTotal = (
    Number(differenceArenda) + Number(differenceNalog)
  ).toFixed(3);

  return (
    <TableContainer component={Paper} style={{ height: "270px"}}>
      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell align="center" colSpan={4}></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="h6">Наименование</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="h6">Начисление</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="h6">Оплата</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="h6">Задолженность</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Аренда</TableCell>
            <TableCell align="right">{totalInvoiceArenda}</TableCell>
            <TableCell align="right">{totalPaymentArenda}</TableCell>
            <TableCell align="right">{differenceArenda}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Налог</TableCell>
            <TableCell align="right">{totalInvoiceNalog}</TableCell>
            <TableCell align="right">{totalPaymentNalog}</TableCell>
            <TableCell align="right">{differenceNalog}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell align="right">
              <Typography variant="h6">Итого:</Typography>
            </TableCell>
            <TableCell align="right">{summaryInvoice}</TableCell>
            <TableCell align="right">{summaryPayment}</TableCell>
            <TableCell align="right">{summuryTotal}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
